import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SearchableComboboxComponent } from './searchable-combobox/searchable-combobox.component';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@NgModule({
  declarations: [SearchableComboboxComponent],
  imports: [CommonModule, FormsModule, MaterialModule],
  exports: [SearchableComboboxComponent],
})
export class SearchableComboboxModule {}
